export default {
    socketBaseUrl:process,
};